import type { RouteRecordRaw } from "vue-router"
import { isAuthenticated } from "@/routers/router-guardians"

const routes: RouteRecordRaw[] = [
  {
    path: "/dashboard/inbox",
    name: "patient-conversations-inbox",
    component: () => import("@/modules/patient-conversations/pages/PatientConversationsInboxPage.vue"),
    beforeEnter(to, from, next) {
      isAuthenticated(to, from, next)
    }
  },
  {
    // The Slack staff feed links here (`APOLLO_URL/patient-conversations/{id}`, see the backend's Slack notifier).
    path: "/patient-conversations/:patientConversationId",
    name: "patient-conversation",
    props: true,
    component: () => import("@/modules/patient-conversations/pages/PatientConversationsInboxPage.vue"),
    beforeEnter(to, from, next) {
      isAuthenticated(to, from, next)
    }
  }
]

export default routes
